module.exports = __webpack_public_path__ + "img/button_check.3454948d.png";